import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

export const StyledCover = styled.div`
  width: 100%;
  margin: auto;
`;

export const StyledMaxWidth = styled.div`
  max-width: 1200px;
  margin: auto;
`;

export const StyledSection = styled.div`
  width: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
`;

export const StyledHeading = styled.h2`
  font-size: 30px;
  text-align: center;
  font-weight: 700;
  color: #136C9D;
  margin-top: 40px;
  margin-bottom: 40px;
`;

export const StyledDetails = styled.div`
  display: flex;
  padding: 20px;
`;

export const StyledItems = styled.div`
  width: 54%;
`;

export const StyledItem = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const StyledLineItem = styled.div`
  display: flex;
`;

export const StyledNumber = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #F1F1F1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;

  &.active{
    background-color: #14A6E4;
    color: white;
  }

  &.read{
    background-color: #DDF5FF;
    color: #218CC3;
  }
`;

export const StyledText = styled.div`
  font-size: 26px;
  font-weight: 600;
  line-height: 1.4;
  color: #393838;
  margin-left: 20px;
  line-height: 32px;
  padding: 6px 10px;
  width: 80%;
  &.active{
    background-color: #F7F7F7;
    box-shadow: 0px 4px 4px 0px rgba(148, 148, 148, 0.25);
  }

  @media(max-width: 600px){
    font-size: 24px;
    line-height: 30px;
    margin-left: 14px;
  }

  @media(max-width: 400px){
    font-size: 22px;
    line-height: 28px;
    margin-left: 14px;
  }
  ${breakpoint('mobile', 'tablet')`
    background-color: #F7F7F7;
    box-shadow: 0px 4px 4px 0px rgba(148, 148, 148, 0.25);
  `}
`;

export const StyledVerticalLine = styled.div`
  background-color: #E4E4E4;
  height: 90px;
  width: 2px;
`;

export const StyledSubText = styled.div`
  color: #888888;
  font-size: 20px;
  margin-left: 20px;
  width: 80%;
  line-height: 26px;
  margin-top: 20px;

  @media(max-width: 600px){
    font-size: 18px;
    line-height: 24px;
    margin-top: 16px;
  }
`;

export const StyledlineWrapper = styled.div`
  width: 40px;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledVideoSection = styled.div`
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledContainer = styled.div`
  padding: 20px;
  ${breakpoint('tablet', 'desktop')`
     padding: 40px;
  `}
`;

export const StyledTextVideoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const StyledVideoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledlineWrapperMobile = styled.div`
  margin-left: 20px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledVerticalLineMobile = styled.div`
  height: 400px;
  width: 1px;
  background-color: #E4E4E4;
`;

export const StyledVideoMobile = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 20px;  
  margin: 10px auto;
  margin-bottom: 28px;
  
  ${breakpoint('mobile', 'desktop')`
    display: flex;
    align-items: center;
    justify-content: center;
  `}

  .videoclass{
    width: 400px;
    height: 400px;

    @media(max-width: 600px){
      width: 80%;
      height: 80%;
    }
    @media(max-width: 450px){
      width: 70%;
      height: 70%;
    }
  }
`;
